import moment from 'moment';
import Base from './Base';

export default class EmployeeSchedule extends Base {
    constructor(props) {
        super();
        this.import(props);
    }

    import(props) {
        if (!props) {
            props = {};
        }

        if (typeof props === 'number') {
            this.id = props;
            return;
        }

        this.id = this.assign('id', props);
        this.shopId = this.assign('shopId', props);
        this.employeeId = this.assign('employeeId', props);
        this.date = this.assign('date', props);
        this.startTime = this.assign('startTime', props);
        this.endTime = this.assign('endTime', props);
        this.status = this.assign('status', props) || 'scheduled';
        this.notes = this.assign('notes', props);
        this.createdById = this.assign('createdById', props);
        this.color = this.assign('color', props);

        // Nested objects
        this.shop = this.assign('shop', props);
        this.employee = this.assign('employee', props);
        this.createdBy = this.assign('createdBy', props);

        this.createdAt = props.createdAt;
        this.updatedAt = props.updatedAt;
    }

    export() {
        return {
            id: this.id,
            shopId: this.shopId,
            employeeId: this.employeeId,
            date: this.date,
            startTime: this.startTime,
            endTime: this.endTime,
            status: this.status,
            notes: this.notes,
            color: this.color
        };
    }

    // Convert to calendar event format for react-big-calendar
    toCalendarEvent() {
        const dateStr = typeof this.date === 'string' ? this.date : moment(this.date).format('YYYY-MM-DD');
        const start = moment(`${dateStr} ${this.startTime}`, 'YYYY-MM-DD HH:mm').toDate();
        const end = moment(`${dateStr} ${this.endTime}`, 'YYYY-MM-DD HH:mm').toDate();

        return {
            id: this.id,
            title: this.employee?.user?.name || `Employee #${this.employeeId}`,
            start,
            end,
            resource: this,
            backgroundColor: this.color || this.employee?.color || '#4CAF50'
        };
    }

    getWorkingHours() {
        const start = moment(this.startTime, 'HH:mm');
        const end = moment(this.endTime, 'HH:mm');

        // Handle overnight shifts
        if (end.isBefore(start)) {
            end.add(1, 'day');
        }

        const totalMinutes = end.diff(start, 'minutes');
        return totalMinutes / 60;
    }
}
